import { normalizePhone } from 'cpool-schemas';
import { formatWhatsAppApplicantSalutation } from 'cpool-utils';

import type { LeadWithApplicants } from './resolveApplicantChats';

export type ApplicantNameParts = {
    firstName: string;
    lastName: string;
    salutation: string | null;
};

/**
 * Preview-side mirror of backend applicant derivation in `deriveTemplateParameters.ts`:
 * pick the applicant matching the chat phone when a co-applicant exists, else primary.
 * Returns null when there is no lead data yet (preview falls back to auto-fill hint / literal tokens).
 */
export function resolveApplicantNameParts(
    lead: LeadWithApplicants | null | undefined,
    chatPhone: string | null | undefined,
): ApplicantNameParts | null {
    if (!lead?.antragsteller1) return null;

    const applicants = lead.antragsteller2 ? [lead.antragsteller1, lead.antragsteller2] : [lead.antragsteller1];
    const normalizedChatPhone = chatPhone ? normalizePhone(chatPhone) : null;

    const applicant =
        applicants.length > 1 && normalizedChatPhone
            ? applicants.find(
                  (entry) =>
                      entry.personendaten.telefonPrivat &&
                      normalizePhone(entry.personendaten.telefonPrivat) === normalizedChatPhone,
              ) ?? lead.antragsteller1
            : lead.antragsteller1;

    const { anrede, nachname, vorname } = applicant.personendaten;
    return {
        firstName: vorname,
        lastName: nachname,
        salutation: formatWhatsAppApplicantSalutation(anrede),
    };
}
